import { defineMessages } from 'react-intl'

export default defineMessages({
  continue: {
    id: 'PartnerPage.continue',
    defaultMessage: 'Continue',
  },
  redeemHeading: {
    id: 'PartnerPage.redeemHeading',
    defaultMessage: 'Redeem your code',
  },
  back: {
    id: 'PartnerPage.back',
    defaultMessage: 'Back',
  },
  createProfile: {
    id: 'PartnerPage.createProfile',
    defaultMessage: 'Create a profile to save your information',
  },
  welcome: {
    id: 'PartnerPage.welcome',
    defaultMessage: 'Welcome to Lifesum',
  },
  createProfileButton: {
    id: 'PartnerPage.createProfileButton',
    defaultMessage: 'Create profile',
  },
  logIn: {
    id: 'PartnerPage.logIn',
    defaultMessage: 'Log in',
  },
  codePlaceholder: {
    id: 'gift_card_enter_code',
    defaultMessage: 'Enter your code',
  },
})
